import React from 'react';
import { connect } from 'react-redux';
import HomeWrapper from './Home.style';
import SideMenu from '../SideMenu/SideMenu';
import Main from '../Main/Main';
import { setOpenKeys, setActiveMenuItemKey } from '../../redux/actions/SideMenu/SidemenuActions';

class Home extends React.Component {

    constructor() {
        super();
        this.handleSubMenuItemSelect = this.handleSubMenuItemSelect.bind(this);
        this.handleMenuItemSelect = this.handleMenuItemSelect.bind(this);
    }

    handleSubMenuItemSelect(key) {
        let open_keys = this.props.SIDEMENUREDUCER.open_keys;
        if (open_keys[0] === key.key) {
            open_keys = [];
        }
        else {
            open_keys[0] = key.key;
        }
        this.props.setOpenKeys(open_keys);
    }

    handleMenuItemSelect(item) {
        this.props.setActiveMenuItemKey(item.keyPath);
    }

    render() {
        return (
            <HomeWrapper>
                <div className="flex home-container">
                    <SideMenu
                        role={this.props.LOGINREDUCER.USER.role}
                        openKeys={this.props.SIDEMENUREDUCER.open_keys}
                        selectedKeys={this.props.SIDEMENUREDUCER.active_menu_item_key}
                        onSubMenuSelect={this.handleSubMenuItemSelect}
                        onMenuItemClick={this.handleMenuItemSelect}
                    />
                    <Main />
                </div>
            </HomeWrapper>
        )
    }
}

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {
    setOpenKeys,
    setActiveMenuItemKey
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/Home/Home.js